/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { eventDetailPayoutListConfig } from '../../config/eventDetail.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IButtonPayoutListPluginMethods extends IPluginMethodMap {
  getButtonPayoutListSync(args?: any): any;
}

export class ButtonPayoutListPlugin implements IAgentPlugin {
  readonly methods: IButtonPayoutListPluginMethods;

  constructor() {
    this.methods = {
      getButtonPayoutListSync: this.getButtonPayoutListSync.bind(this),
    };
  }

  async getButtonPayoutListSync(args?: any) {
    return {
      //error:eventDetailPayoutListConfig

      buttons: await this.getButtons(args),
    };
  }

  private async getButtons(args: any) {
    let _buttons = [];
    _buttons.push(eventDetailPayoutListConfig?.timeLineButton);
    let whoami = await getWhoamiSrv()?.whoAmI();
    if (whoami?.whoami === 'RISK_CAPITAL' && args?.status === 'ACTIVE') {
      _buttons = [...eventDetailPayoutListConfig?.buttons, ..._buttons];
    }
    return _buttons;
  }
}
